import axios from 'lib/axios'

interface DeleteUsersResponse {
  success: boolean
  message?: string
  data?: any
}

const test360DeleteUsers = async (processId: number, users: string[]): Promise<DeleteUsersResponse> => {
  const apiUrl = `/process/draft/delete/users/${processId}`

  try {
    const response = await axios.put(apiUrl, { users })
    return response.data
  } catch (error: any) {
    console.error('Error deleting users from test 360 draft:', error)
    return {
      success: false,
      message: error?.response?.data?.message || 'Error al eliminar usuarios del borrador Test 360',
      data: error?.response?.data
    }
  }
}

export default test360DeleteUsers
